import Vue from 'vue';
import moment from 'moment';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'fundLoanManageListExpend',
    props: {
        scopeData: {
            type: Object,
            default: function () {
                return {
                    data: {},
                };
            },
        },
    },
    data: function () {
        var _this = this;
        return {
            loading: false,
            capitalRepayPlanDTOList: [],
            planTableDataConfig: [
                {
                    label: '费用类型',
                    prop: 'costType',
                    minWidth: '80px',
                    formatter: function () {
                        return '本期金额';
                    },
                },
                {
                    label: '期数',
                    prop: 'costType',
                    minWidth: '50px',
                    formatter: function (current, row, index) {
                        return index + 1;
                    },
                },
                {
                    label: '还款周期',
                    prop: 'date',
                    minWidth: '210px',
                    formatter: function (current, row) {
                        var startTime = row.startTime, endTime = row.endTime;
                        return (startTime ? moment(startTime).format('YYYY-MM-DD') : '--') + " \u81F3 " + (endTime ? moment(endTime).format('YYYY-MM-DD') : '--');
                    },
                },
                {
                    label: '还款模式',
                    prop: 'deductMode',
                    minWidth: '110px',
                    formatter: function (current) {
                        var deductModes = {
                            DAILY_DEDUCT_AVG: '日扣平均',
                            DAILY_DEDUCT_PRIOR: '日扣优先',
                        };
                        return current ? deductModes[current] : '--';
                    },
                },
                {
                    label: '还款状态',
                    prop: 'status',
                    minWidth: '75px',
                    formatter: function (current) {
                        var statusObj = {
                            WAITING_REPAY: '待还款',
                            REPAYING: '还款中',
                            PAID_OFF: '已还清',
                            OVERDUE: '已逾期',
                            TERMINAL: '已停用',
                        };
                        return current ? statusObj[current] : '--';
                    },
                },
                {
                    label: '月还款金额（元）',
                    prop: 'planAmount',
                    minWidth: '130px',
                    align: 'right',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '已还金额（元）',
                    prop: 'paidAmount',
                    minWidth: '120px',
                    align: 'right',
                    formatter: function (current) {
                        return current ? toYuan(current).toFixed(2) : '--';
                    },
                },
                {
                    label: '待还金额（元）',
                    prop: 'waitAmount',
                    align: 'right',
                    minWidth: '120px',
                    formatter: function (current, row) {
                        var planAmount = row.planAmount, paidAmount = row.paidAmount;
                        if ((planAmount === 0 || planAmount) &&
                            (paidAmount === 0 || paidAmount)) {
                            var waitAmount = planAmount - paidAmount;
                            return waitAmount ? toYuan(waitAmount).toFixed(2) : '--';
                        }
                        return '--';
                    },
                },
                {
                    label: '操作',
                    prop: 'opt',
                    buttons: [
                        {
                            label: '扣款明细',
                            callback: function (row) {
                                var capitalName = row.capitalName, startTime = row.startTime, endTime = row.endTime;
                                _this.$router.push({
                                    path: '/console/loan-manage/loan-detail',
                                    query: {
                                        capitalName: capitalName,
                                        startTime: moment(startTime).format('YYYY-MM-DD'),
                                        endTime: moment(endTime).format('YYYY-MM-DD'),
                                    },
                                });
                            },
                            isShow: function (row) {
                                var status = row.status;
                                return status !== 'WAITING_REPAY';
                            },
                        },
                    ],
                },
            ],
            cellConfig: {
                status: [
                    {
                        status: 'OVERDUE',
                        style: 'color:#FF5257',
                    },
                    {
                        status: 'REPAYING',
                        style: 'color:#28AA91',
                    },
                    {
                        status: 'TERMINAL',
                        style: 'color:#858B9C',
                    },
                    {
                        status: 'PAID_OFF',
                        style: 'color:#858B9C',
                    },
                ],
            },
        };
    },
    computed: {
        totalAmount: function () {
            var total = 0;
            if (this.capitalRepayPlanDTOList &&
                this.capitalRepayPlanDTOList.length > 0) {
                this.capitalRepayPlanDTOList.forEach(function (item) {
                    total += item.planAmount;
                });
            }
            return toYuan(total);
        },
    },
    created: function () {
        this.getPlanList();
    },
    methods: {
        getPlanList: function () {
            var _this = this;
            var _a = this.scopeData.data, capitalCode = _a.capitalCode, contractCode = _a.contractCode;
            this.loading = true;
            this.$request({
                url: "/proxy/fund-api/capital/repay/plan/list",
                method: 'post',
                data: {
                    capitalCode: capitalCode,
                    contractCode: contractCode,
                },
                loadingControl: 'hand',
            }).then(function (res) {
                _this.loading = false;
                if (!res || res.errorCode !== 0) {
                    return;
                }
                if (res.data) {
                    _this.capitalRepayPlanDTOList = res.data;
                }
            });
        },
        viewAppendix: function (row) {
            this.$emit('update-dialog-config', {
                dialogConfig: {
                    dialogTitle: '附录',
                    flag: 'appendix',
                    width: '560px',
                    data: row,
                },
                dialogVisible: true,
            });
        },
        cellStyle: function (_a) {
            var row = _a.row, column = _a.column;
            var cellConfig = this.cellConfig;
            var keys = typeof cellConfig && cellConfig !== null ? Object.keys(cellConfig) : [];
            var styles = '';
            if (keys.length > 0) {
                keys.forEach(function (item) {
                    if (column.property === item) {
                        cellConfig[item].forEach(function (eItem) {
                            var status = eItem.status, style = eItem.style, flag = eItem.flag;
                            if (!flag) {
                                if (row[item] === status) {
                                    styles = style;
                                }
                            }
                            else {
                                row[flag] === status ? (styles = style) : '';
                            }
                        });
                    }
                });
            }
            return styles;
        },
        tableRowClassName: function (_a) {
            var row = _a.row;
            var status = row.status;
            if (status === 'OVERDUE') {
                return 'item-overdue';
            }
            if (status === 'TERMINAL' || status === 'PAID_OFF') {
                return 'item-complate';
            }
            return '';
        },
    },
});
